export default __webpack_public_path__ + "static/me150copy-ecfcf1c45b4287fccca7e92835dd00c6.png";